/*@ngInject*/
const SectionTemplateEditorModel = function ($rootScope, configurationMediator, configurationConstant, sectionTemplateApplicabilityType) {

    let sectionTemplateEditorModel = {};

    this.reset = function (sectionTemplateId) {
        if (!_.isNil(sectionTemplateId)) {
            sectionTemplateEditorModel[sectionTemplateId] = {
                sectionTemplate: null,
                quoteDocumentTemplateFile: null,
                isValid: null,
                isValidToSave: null,
                isValidRule: null,
                isValidRuleToSave: null,
                hasUnsavedPropertiesChanges: false,
                hasUnsavedRuleChanges: false,
                hasUnsavedQuoteDocumentTemplateFile: false
            };
        } else {
            sectionTemplateEditorModel = {};
        }
    };

    this.buildSectionTemplate = function (sectionTemplateId) {
        this.reset(sectionTemplateId);

        if (sectionTemplateId === -1) { // New section template
            this.updateSectionTemplate({
                id: -1,
                name: null,
                description: null,
                active: true,
                applicability: sectionTemplateApplicabilityType.OPTIONAL,
                applicableToBinder: false,
                applicableToProposal: true,
                productTemplates: [],
                ordinalNumber: null,
                stitchable: true,
                formTemplateUniqueName: null,
                adapterBeanName: null,
                documentTemplateName: null
            });
        } else {
            configurationMediator.getSectionTemplateById(sectionTemplateId).then(function (sectionTemplate) {
                this.updateSectionTemplate(sectionTemplate);
            }.bind(this));
        }
    };

    this.getSectionTemplate = function (sectionTemplateId) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        return model.sectionTemplate;
    };

    this.setValid = function (sectionTemplateId, valid) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        model.isValid = valid;
        model.isValidToSave = valid;
    };

    this.isValid = function (sectionTemplateId) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        return model.isValid;
    };

    this.setValidRule = function (sectionTemplateId, valid) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        model.isValidRule = valid;
        model.isValidRuleToSave = valid;
    };

    this.isValidRule = function (sectionTemplateId) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        return model.isValidRule;
    };

    this.setUnsavedRuleChanges = function (sectionTemplateId, hasUnsavedChanges) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        model.hasUnsavedRuleChanges = hasUnsavedChanges;
    };

    this.hasUnsavedRuleChanges = function (sectionTemplateId) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        return model.hasUnsavedRuleChanges;
    };

    this.setUnsavedPropertiesChanges = function (sectionTemplateId, hasUnsavedChanges) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        model.hasUnsavedPropertiesChanges = hasUnsavedChanges;
    };

    this.hasUnsavedPropertiesChanges = function (sectionTemplateId) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        return model.hasUnsavedPropertiesChanges;
    };

    this.isValidToSave = function (sectionTemplateId) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        return _.isNil(model.isValidToSave) || model.isValidToSave;
    };

    this.isValidRuleToSave = function (sectionTemplateId) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        return _.isNil(model.isValidRuleToSave) || model.isValidRuleToSave;
    };

    this.setQuoteDocumentTemplateFile = function (sectionTemplateId, file) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        model.quoteDocumentTemplateFile = file;
    };

    this.getQuoteDocumentTemplateFile = function (sectionTemplateId) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        return model.quoteDocumentTemplateFile;
    };

    this.setUnsavedQuoteDocumentTemplateFile = function (sectionTemplateId, hasUnsavedFile) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        model.hasUnsavedQuoteDocumentTemplateFile = hasUnsavedFile;
    };

    this.hasUnsavedQuoteDocumentTemplateFile = function (sectionTemplateId) {
        const model = sectionTemplateEditorModel[sectionTemplateId];
        return model.hasUnsavedQuoteDocumentTemplateFile;
    }

    this.updateSectionTemplate = function (sectionTemplate) {
        let model = {
            sectionTemplate: _.cloneDeep(sectionTemplate),
            quoteDocumentTemplateFile: null,
            isValid: null,
            isValidToSave: null,
            isValidRule: null,
            isValidRuleToSave: null,
            hasUnsavedPropertiesChanges: false,
            hasUnsavedRuleChanges: false,
            hasUnsavedQuoteDocumentTemplateFile: false
        };

        sectionTemplateEditorModel[sectionTemplate.id] = model;

        $rootScope.$broadcast(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, sectionTemplate.id);
    };
};

angular.module('ums.configuration')
    .service('sectionTemplateEditorModel', SectionTemplateEditorModel);
